import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeService } from '../services/employee.service';
import { UtilsService } from '../services/utils.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.css']
})
export class EmployeeDetailsComponent implements OnInit {


  selectedEmployee: EmployeeDetails = null;
  editableEmployee: EmployeeDetails = null;
  employeeNewPassword: string = "";
  sendPasswordEmail: boolean = false;
  loadingEmployee: boolean = false;
  empid: string = null;

  // edit employee
  showEditInfoModal: boolean = false;
  showEditWorkerInfoModal: boolean = false;
  showEditBasicInfoModal: boolean = false;
  showChangePasswordModal: boolean = false;
  isSavingInfo: boolean = false;
  disabledSaveButton: boolean = false;
  successMessage: string = "";
  errorMessage: string = "";
  fileNumberAvailable: boolean = true;

  user: User = null;

  constructor(
    private route: ActivatedRoute, 
    private router: Router, 
    private employeeService: EmployeeService, 
    private utilService: UtilsService, 
    private authService: AuthService) { }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.empid = params.get('employee_id');
      if (this.empid) {
        this.loadEmployeeDetails(this.empid);
      }
    });

    this.user = this.authService.getUserFromToken();
  }

  showEditWorkerInfo() {
    this.showEditWorkerInfoModal = true;
    this.editableEmployee = { ...this.selectedEmployee };
  }

  showEditInfo() {
    this.showEditInfoModal = true;
    this.editableEmployee = { ...this.selectedEmployee };
  }

  showEditBasicInfo(){
    this.showEditBasicInfoModal = true;
    this.editableEmployee = { ...this.selectedEmployee };
  }

  resetMessages(){
    this.successMessage = "";
    this.errorMessage = "";
    this.disabledSaveButton = false;
  }

  autoCloseModal(ms: number = 1500) {
    this.isSavingInfo = false;
    setTimeout(() => {
      this.showEditBasicInfoModal = false;
      this.showEditInfoModal = false;
      this.showEditWorkerInfoModal = false;
      this.resetMessages();
      this.disabledSaveButton = false;
    }, ms);
  }

  async loadEmployeeDetails(empid: string) {
    this.resetMessages();
    try {
      this.loadingEmployee = true;
      let result = await this.employeeService.getEmployeeDetails(empid).toPromise();
      this.selectedEmployee = result;
      document.querySelector<HTMLElement>(".routed-content").style.display = "block";
      document.querySelector<HTMLElement>(".routed-container").style.removeProperty('height');
      if (!result) {
        this.errorMessage = "Employee not found.";
      }
    } catch (error) {
      this.errorMessage = error.error?.detail ?? "Failed to load employee details. Please try again later.";
    } finally {
      this.loadingEmployee = false;
    }
  }

  fullAddress() {
    if (!this.selectedEmployee) return "";
    let address = [this.selectedEmployee.address_2,
    this.selectedEmployee.address_1,
    this.selectedEmployee.city,
    this.selectedEmployee.state,
    this.selectedEmployee.zip_code];
    address = address.filter((item) => item !== "");
    return address.join(", ")
  }

  async saveContactInfo() {
    this.resetMessages();
    this.disabledSaveButton = true;
    try {
      let payload = {
        "phone": this.editableEmployee.phone,
        "address_1": this.editableEmployee.address_1,
        "address_2": this.editableEmployee.address_2,
        "city": this.editableEmployee.city,
        "state": this.editableEmployee.state,
        "zip_code": this.editableEmployee.zip_code,
      }
      this.isSavingInfo = true;
      let result = await this.employeeService.updateEmployeeContactInfo(this.selectedEmployee.employee_id, payload).toPromise();
      if (result) {
        this.selectedEmployee = result;
        this.successMessage = "Contact Information has been updated!";
        this.autoCloseModal();
        this.selectedEmployee = { ...this.editableEmployee };
        // update the coordinates
        this.selectedEmployee.latitude = result.latitude;
        this.selectedEmployee.longitude = result.longitude;
      }
    } catch (error) {
      this.errorMessage = error.error?.detail ?? "Something went wrong on our end. Please try again later.";
      this.isSavingInfo = false;
    }
  }

  async saveWorkerInfo() {
    this.resetMessages();
    this.disabledSaveButton = true;
    try {
      let payload = {
        "contractor": this.editableEmployee.contractor,
        "paperwork": this.editableEmployee.paperwork,
        "waiting_on_new_paperwork": this.editableEmployee.waiting_on_new_paperwork,
        "active": this.editableEmployee.active,
        "employee_type": this.editableEmployee.employee_type,
        "QM_rate": this.editableEmployee.QM_rate,
        "hourly_rate": this.editableEmployee.hourly_rate,
        "can_host_online": this.editableEmployee.can_host_online,
        "can_host_trivia": this.editableEmployee.can_host_trivia,
        "can_host_ss": this.editableEmployee.can_host_ss,
        "can_host_bingo": this.editableEmployee.can_host_bingo,
      }
      this.isSavingInfo = true;
      let result = await this.employeeService.updateEmployeeContactInfo(this.selectedEmployee.employee_id, payload).toPromise();
      if (result) {
        this.selectedEmployee = result;
        this.successMessage = "Worker Information has been updated!";
        this.autoCloseModal();
        this.selectedEmployee = {...this.editableEmployee};
      }
    } catch (error) {
      this.errorMessage = error.error?.detail ?? "Something went wrong on our end. Please try again later.";
      this.isSavingInfo = false;
    }
  }

  async saveBasicInfo() {
    this.resetMessages();
    this.disabledSaveButton = true;
    try {
      let payload = {
        "first_name": this.editableEmployee.first_name,
        "last_name": this.editableEmployee.last_name,
        "legal_first_name": this.editableEmployee.legal_first_name,
        "legal_last_name": this.editableEmployee.legal_last_name,
        "file_number": this.editableEmployee.file_number,
      }
      this.isSavingInfo = true;
      let result = await this.employeeService.updateEmployeeContactInfo(this.selectedEmployee.employee_id, payload).toPromise();
      if (result) {
        this.selectedEmployee = result;
        this.successMessage = "Basic Information has been updated!";
        this.autoCloseModal();
        this.selectedEmployee = { ...this.editableEmployee };
      }
    } catch (error) {
      this.errorMessage = error.error?.detail ?? "Something went wrong on our end. Please try again later.";
      this.isSavingInfo = false;
      this.disabledSaveButton = false;
    }
  }

  generatePassword() {
    const upper = "ABCDEFGHJKLMNP7RSTUVWXYZ";
    const lower = "fghijkmnpqrstuvwxyz";
    const digits = "2348";
    const special = "!@#$^&*()_+[]{}|:.<>?";
    const chars = upper + lower + digits + special;

    let password = [
      upper.charAt(Math.floor(Math.random() * upper.length)),
      lower.charAt(Math.floor(Math.random() * lower.length)),
      digits.charAt(Math.floor(Math.random() * digits.length)),
      special.charAt(Math.floor(Math.random() * special.length))
    ];

    for (let i = password.length; i < 12; i++) {
      password.push(chars.charAt(Math.floor(Math.random() * chars.length)));
    }

    password = password.sort(() => Math.random() - 0.5);

    this.employeeNewPassword = password.join('');

  }

  copyPassword() {
    const passwordInput = document.querySelector<HTMLInputElement>("#new-password");
    if (passwordInput) {
      passwordInput.select();
      navigator.clipboard.writeText(passwordInput.value).then(() => {
        this.successMessage = "Password copied to clipboard!";
      });

      setTimeout(() => {
        this.successMessage = "";
      }, 1400);
    } else {
      this.successMessage = "Failed to copy password.";
    }
  }

  async saveNewPassword() {
    this.resetMessages();
    this.disabledSaveButton = true;
    try {
      if (!this.employeeNewPassword || this.employeeNewPassword.length < 8) {
        this.successMessage = "Password must be at least 8 characters long.";
        return;
      }
      let payload = {
        "new_password": this.employeeNewPassword,
        "send_email": this.sendPasswordEmail
      }
      this.isSavingInfo = true;
      let result = await this.employeeService.updateEmployeePassword(this.selectedEmployee.employee_id, payload).toPromise();
      if (result) {
        this.successMessage = "Password has been updated!";
        this.autoCloseModal();
        this.showChangePasswordModal = false;
        this.employeeNewPassword = "";
        this.sendPasswordEmail = false;
      }
    } catch (error) {
      this.errorMessage = error.error?.detail ?? "Something went wrong on our end. Please try again later.";
      this.isSavingInfo = false;
    }
  }


}
